import * as actions from "./actionTypes/index";

export const GameMarketsListUpdateReceived = (payload, key) => {
    return {
        type: actions.GAME_MARKETS_LIST_UPDATE_RECEIVED,
        key,
        payload
    };
};

export const ResetGameMarketsList = (key) => {
    return {
        type: actions.RESET_GAME_MARKETS_LIST,
        key
    };
};